import { Tooltip } from 'antd'
import { breakpoints } from 'style'
import styled from 'styled-components'

export const TooltipContainer = styled(Tooltip)`
  cursor: pointer;
  @media (max-width: ${breakpoints.xl}px) {
  }
`
